export const LOGIN_OTP_LENGTH = 4;

export const LOGIN_PHONE_NUMBER_LENGTH = 10;

export const LOGIN_STEP_TRANSITION_MS = 500;
